const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNavToggleRing(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 38.168,
    height: 38.167,
    viewBox: "0 0 38.168 38.167",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group 6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    d: "M1.05176 25.084C2.93643 30.7509 7.41707 35.2315 13.084 37.1162V38.167C6.86408 36.2133 1.95361 31.3039 0 25.084H1.05176ZM38.168 25.084C36.2144 31.3039 31.3039 36.2133 25.084 38.167V37.1162C30.7509 35.2315 35.2315 30.7509 37.1162 25.084H38.168ZM25.084 0C31.304 1.95364 36.2143 6.86395 38.168 13.084H37.1162C35.2315 7.41697 30.751 2.9354 25.084 1.05078V0ZM13.084 1.05078C7.41693 2.9354 2.93646 7.41697 1.05176 13.084H0C1.95364 6.86395 6.86395 1.95364 13.084 0V1.05078Z",
    fill: "white",
    fillOpacity: 0.4,
    style: {
      fill: "white",
      fillOpacity: 0.4
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavToggleRing);
export default __webpack_public_path__ + "static/media/nav-toggle-ring.f3a10d78c8d701cd86ccbd4ef6c9ba62.svg";
export { ForwardRef as ReactComponent };